import Component from 'antd/es/alert';
import 'antd/lib/alert/style';
export default Component;
